import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'ngx-form-dropdown',
  templateUrl: './form-dropdown.component.html',
  styleUrls: ['./form-dropdown.component.scss'],
})
export class FormDropdownComponent implements OnInit {
  @Input() title = 'Type';
  @Input() options: any[];
  @Input() displayField: string = 'name';
  @Input() keyField: string = 'id';
  @Input() value: any;
  @Input() noTitle = false;
  @Input() disabled: boolean = false;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  updateValue(event) {
    if (event === 'null') event = null;
    this.valueChange.emit(event);
  }

}
